__turbopack_context__.v({
  "formGroup": "DKMembershipWidget-module-scss-module__hZUDmq__formGroup",
  "membershipNotificationCloseButton": "DKMembershipWidget-module-scss-module__hZUDmq__membershipNotificationCloseButton",
  "membershipNotificationContent": "DKMembershipWidget-module-scss-module__hZUDmq__membershipNotificationContent",
  "membershipNotificationIcon": "DKMembershipWidget-module-scss-module__hZUDmq__membershipNotificationIcon",
  "membershipNotificationMessage": "DKMembershipWidget-module-scss-module__hZUDmq__membershipNotificationMessage",
  "membershipNotificationWrapper": "DKMembershipWidget-module-scss-module__hZUDmq__membershipNotificationWrapper",
  "submitButton": "DKMembershipWidget-module-scss-module__hZUDmq__submitButton",
  "submitSpinner": "DKMembershipWidget-module-scss-module__hZUDmq__submitSpinner",
  "warningMessage": "DKMembershipWidget-module-scss-module__hZUDmq__warningMessage",
  "widgetContainer": "DKMembershipWidget-module-scss-module__hZUDmq__widgetContainer",
});
